import React from "react";

export default function Marquee() {
  const items = ["Provably fair", "Math first", "Stake exclusive", "Gumble studio"];
  return (
    <div className="relative py-3 overflow-hidden border-y hairline">
      <div className="flex gap-10 whitespace-nowrap animate-[marquee_40s_linear_infinite]">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="flex gap-10 items-center">
            {items.map((t) => (
              <span key={t + i} className="text-[13px] tracking-[0.2em] uppercase text-white/40">
                {t} <span className="mx-6 text-white/30">—</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
